export const PALETTE = ["#93c5fd", "#86efac", "#fcd34d", "#c4b5fd", "#f9a8d4", "#5eead4", "#fdba74", "#a5b4fc"];
export const CELL_COLORS = { WO: "#e2e8f0", H: "#fde68a", L: "#fecaca" };
export const CELL_NAMES = { WO: "Weekly off", H: "Holiday", L: "Leave" };
export const WEEKDAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export function shiftColours(shifts) {
  const out = {};
  [...shifts].sort((a, b) => (a.start || "").localeCompare(b.start || "")).forEach((s, i) => {
    const c = (s.colour || "").toLowerCase();
    out[s.code] = c && c !== "#6366f1" ? c : PALETTE[i % PALETTE.length];
  });
  return { ...out, ...CELL_COLORS };
}

export async function downloadBlob(api, url, fname) {
  const res = await api.get(url, { responseType: "blob" });
  const u = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = u; a.download = fname; a.click(); URL.revokeObjectURL(u);
}
